/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: "ap-south-1",
  aws_cognito_region: "ap-south-1",
  aws_user_pools_id: process.env.NEXT_PUBLIC_COGNITO_POOL,
  aws_user_pools_web_client_id: process.env.NEXT_PUBLIC_COGNITO_APPID,
  oauth: {
    domain: process.env.NEXT_PUBLIC_COGNITO_DOMAIN,
    scope: ["phone", "email", "openid", "profile", "aws.cognito.signin.user.admin"],
    redirectSignIn: process.env.NEXT_PUBLIC_COGNITO_RETURN_URL,
    redirectSignOut: process.env.NEXT_PUBLIC_COGNITO_RETURN_URL + "?signout",
    responseType: "token"
  },
  federationTarget: "COGNITO_USER_POOLS",
  aws_cognito_username_attributes: ["EMAIL", "PHONE_NUMBER"],
  aws_cognito_social_providers: ["FACEBOOK", "GOOGLE"],
  aws_cognito_signup_attributes: [],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: ["SMS"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: ["REQUIRES_UPPERCASE", "REQUIRES_NUMBERS"]
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
  aws_cloud_logic_custom: [
    {
      name: "AdminQueries",
      endpoint: "https://dl7n0awh1f.execute-api.ap-south-1.amazonaws.com/uat",
      region: "ap-south-1"
    }
  ]
};

export default awsmobile;
